import TortasMaster from './TortasMaster'
export default class CompraPie extends TortasMaster {
    state = { title: '', values: [] };
    estados = ['CANCELADO', 'SIN FACTURA', 'FACTURADA'];
    api = 'Compra';
    title='COMPRAS'
}